export const DBS_TYPE_OPTIONS = [
  { value: "basic", label: "Basic DBS" },
  { value: "standard", label: "Standard DBS" },
  { value: "enhanced", label: "Enhanced DBS" },
  { value: "enhancedPlus", label: "Enhanced DBS + Barred List" },
];

export const WORKFORCE_OPTIONS = [
  { value: "child", label: "Child Workforce" },
  { value: "adult", label: "Adult Workforce" },
  { value: "both", label: "Both" },
];

const DBS_TYPES_REQUIRING_WORKFORCE = new Set(["enhanced", "enhancedPlus"]);

export const dbsTypeRequiresWorkforce = (dbsType) =>
  DBS_TYPES_REQUIRING_WORKFORCE.has(String(dbsType ?? "").trim());

export const workForceApiToUi = (workForce, dbsType) => {
  if (!dbsTypeRequiresWorkforce(dbsType)) return "";
  if (workForce === "child") return "child";
  if (workForce === "adult") return "adult";
  return "both";
};

export const workForceUiToApi = (workForceUi) => {
  if (workForceUi === "child") return "child";
  if (workForceUi === "adult") return "adult";
  if (workForceUi === "both") return null;
  return undefined;
};

/** Map API DBS compliance row → admin approval form row */
export const mapDbsItemFromApi = (dbsItem) => {
  const dbsType = String(dbsItem?.dbsType ?? "").trim();
  return {
    dbsSlug: dbsItem?.dbsCert?.slug || dbsItem?.dbsSlug || "",
    status: dbsItem?.status ?? false,
    issueDate: dbsItem?.issueDate || "",
    certificateRef: dbsItem?.certificateRef || "",
    lastCheckedDate: dbsItem?.lastCheckedDate || "",
    expiryDate: dbsItem?.expiryDate || "",
    dbsType,
    workForceUi: workForceApiToUi(dbsItem?.workForce, dbsType),
  };
};

/** Map admin approval form row → API compliance DBS payload */
export const mapDbsItemToApi = (row) => {
  const out = {
    dbsSlug: String(row?.dbsSlug ?? "").trim(),
    status: !!row?.status,
  };

  // Only include optional fields if they have values
  const issueDate = String(row?.issueDate ?? "").trim();
  if (issueDate) out.issueDate = issueDate;

  const certificateRef = String(row?.certificateRef ?? "").trim();
  if (certificateRef) out.certificateRef = certificateRef;

  const lastCheckedDate = String(row?.lastCheckedDate ?? "").trim();
  if (lastCheckedDate) out.lastCheckedDate = lastCheckedDate;

  if (!out.status) return out;

  const dbsType = String(row?.dbsType ?? "").trim();
  if (dbsType) out.dbsType = dbsType;
  if (dbsTypeRequiresWorkforce(dbsType) && row?.workForceUi) {
    out.workForce = workForceUiToApi(row.workForceUi);
  }

  const expiryDate = String(row?.expiryDate ?? "").trim();
  if (expiryDate) out.expiryDate = expiryDate;

  return out;
};

export const buildDbsCompliancePayload = (rows) =>
  (Array.isArray(rows) ? rows : []).map(mapDbsItemToApi);

export const isCvCertificate = (certSlug) =>
  String(certSlug ?? "")
    .trim()
    .toLowerCase()
    .startsWith("cv-");

export const mapOtherCertItemToApi = (row) => {
  const out = {
    certSlug: String(row?.certSlug ?? "").trim(),
    status: !!row?.status,
  };
  if (out.status) {
    if (isCvCertificate(out.certSlug)) {
      out.expiryDate = null;
    } else {
      const expiryDate = String(row?.expiryDate ?? "").trim();
      if (expiryDate) out.expiryDate = expiryDate;
    }
  }
  return out;
};

export const buildOtherCertsCompliancePayload = (rows) =>
  (Array.isArray(rows) ? rows : []).map(mapOtherCertItemToApi);
